// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Belt_Array = require("bs-platform/lib/js/belt_Array.js");
var Belt_SetString = require("bs-platform/lib/js/belt_SetString.js");
var Directives$XodArduino = require("./Directives.bs.js");

function getEvaluateOnPinSettings(code) {
  var param = Directives$XodArduino.getEvaluateOnPinSettings(code);
  return {
          enabled: param.enabled,
          exceptions: Belt_SetString.toArray(param.exceptions)
        };
}

function findXodPragmas(code) {
  return Belt_Array.map(Belt_List.toArray(Directives$XodArduino.findXodPragmas(code)), Belt_List.toArray);
}

function findRequireUrls(code) {
  return Belt_List.toArray(Directives$XodArduino.findRequireUrls(code));
}

var isDirtienessEnabled = Directives$XodArduino.isDirtienessEnabled;

var doesCatchErrors = Directives$XodArduino.doesCatchErrors;

var isNodeIdEnabled = Directives$XodArduino.isNodeIdEnabled;

var doesRaiseErrors = Directives$XodArduino.doesRaiseErrors;

var areTimeoutsEnabled = Directives$XodArduino.areTimeoutsEnabled;

var isSetImmediateEnabled = Directives$XodArduino.isSetImmediateEnabled;

var stripCppComments = Directives$XodArduino.stripCppComments;

exports.isDirtienessEnabled = isDirtienessEnabled;
exports.doesCatchErrors = doesCatchErrors;
exports.isNodeIdEnabled = isNodeIdEnabled;
exports.doesRaiseErrors = doesRaiseErrors;
exports.getEvaluateOnPinSettings = getEvaluateOnPinSettings;
exports.areTimeoutsEnabled = areTimeoutsEnabled;
exports.isSetImmediateEnabled = isSetImmediateEnabled;
exports.stripCppComments = stripCppComments;
exports.findXodPragmas = findXodPragmas;
exports.findRequireUrls = findRequireUrls;
/* No side effect */
